<template>
  <el-dialog title="请选择人员名单覆盖方式" :visible="true" width="30%">
    <div class="pb20">
      <el-radio v-model="radio" :label="1">按当前人员名单执行</el-radio>
      <p style="color:red" class="pl10">
        不存在于当前导入表单的自然人将看不到此项目
      </p>
    </div>
    <div>
      <el-radio v-model="radio" :label="2">新增当前人员名单</el-radio>
      <p style="color:red" class="pl10">
        当前导入表单内的自然人将新增到项目人员列表项目人员列表内已存在的自然人可继续执行
      </p>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="() => $emit('close')">取 消</el-button>
      <el-button type="primary" @click="submit">
        确 定
      </el-button>
    </span>
  </el-dialog>
</template>

<script>
export default {
  name: 'add-users-pre',
  data() {
    return {
      radio: null
    };
  },
  methods: {
    submit() {
      if (!this.radio) {
        this.$alert('请选择人员名单覆盖方式');
        return;
      }
      this.$emit('ok', this.radio);
    }
  }
};
</script>

<style scoped></style>
